"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEbtsConfig = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const defaultConfig = {
    ebtsGen: undefined,
    get processTransactionsCronTime() {
        var _a;
        return ((_a = process.env.EBTS_CRON_TIME) !== null && _a !== void 0 ? _a : 
        // default: runs "At every minute." (see https://crontab.guru)
        '* * * * *');
    },
    ebtsReceiverConfig: {
        authorizationCredentials: {
            get username() {
                var _a;
                return (_a = process.env.EBTS_RECEIVE_EMAIL_USERNAME) !== null && _a !== void 0 ? _a : '';
            },
            get password() {
                var _a;
                return (_a = process.env.EBTS_RECEIVE_EMAIL_PASSWORD) !== null && _a !== void 0 ? _a : '';
            }
        },
        protocol: 'EMAIL',
        protocolSettings: {
            emailAccessType: 'POP3',
            get emailFromWhitelist() {
                const customWhiteList = process.env.EBTS_RECEIVE_EMAIL_FROM_WHITELIST
                    ? process.env.EBTS_RECEIVE_EMAIL_FROM_WHITELIST.split(',')
                    : undefined;
                return customWhiteList !== null && customWhiteList !== void 0 ? customWhiteList : ['2fast2safis@gmail.com'];
            },
            get serverPOPHost() {
                var _a;
                return (_a = process.env.EBTS_RECEIVE_EMAIL_HOST) !== null && _a !== void 0 ? _a : 'pop.gmail.com';
            },
            get serverPOPPort() {
                const customPort = process.env.EBTS_RECEIVE_EMAIL_PORT ? +process.env.EBTS_RECEIVE_EMAIL_PORT : undefined;
                return customPort !== null && customPort !== void 0 ? customPort : 995;
            },
            logDebug: false,
            errsTLS: true,
            enableTLS: true,
            ignoretlserrs: true
        },
        deleteAfterRead: false,
        responseMessageFields: undefined,
        parseBookingNumberFromResponse: undefined,
        parseMessageFromResponse: undefined
    },
    ebtsTransmissionConfig: {
        authorizationCredentials: {
            get username() {
                var _a;
                return (_a = process.env.EBTS_SEND_EMAIL_USERNAME) !== null && _a !== void 0 ? _a : '';
            },
            get password() {
                var _a;
                return (_a = process.env.EBTS_SEND_EMAIL_PASSWORD) !== null && _a !== void 0 ? _a : '';
            }
        },
        protocol: 'EMAIL',
        protocolSettings: {
            get host() {
                var _a;
                return (_a = process.env.EBTS_SEND_EMAIL_HOST) !== null && _a !== void 0 ? _a : 'smtp.gmail.com';
            },
            get port() {
                const customPort = process.env.EBTS_SEND_EMAIL_PORT ? +process.env.EBTS_SEND_EMAIL_PORT : undefined;
                return customPort !== null && customPort !== void 0 ? customPort : 587;
            },
            get secure() {
                const customSecure = process.env.EBTS_SEND_EMAIL_SECURE
                    ? process.env.EBTS_SEND_EMAIL_SECURE.toLowerCase() === 'true'
                    : undefined;
                return customSecure !== null && customSecure !== void 0 ? customSecure : false;
            },
            get defaultFrom() {
                var _a;
                return (_a = process.env.EBTS_SEND_EMAIL_DEFAULT_FROM) !== null && _a !== void 0 ? _a : 'ebts@gmail.com';
            },
            get toEmailAddress() {
                var _a;
                return (_a = process.env.EBTS_SEND_EMAIL_TO_ADDRESS) !== null && _a !== void 0 ? _a : '2fast2safis@gmail.com';
            }
        }
    }
};
function createEbtsConfig(config) {
    // merge the default config with the provided values
    return merge_1.default({}, defaultConfig, config);
}
exports.createEbtsConfig = createEbtsConfig;
//# sourceMappingURL=ebts-partial.js.map